var _mask, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSatellite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "satellite_svg__a",
    width: 22,
    height: 22,
    x: 0,
    y: 0,
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m6.642 9.044 2.402-2.402c.218-.219.51-.219.728 0l.8.8.146-2.329c0-.106.039-.174.088-.26.019-.031.038-.065.058-.104L15.521.164c.218-.219.51-.219.655 0l3.421 3.348c.146.218.146.51 0 .655L14.94 8.825c-.073.073-.219.146-.291.146l-2.33.218.8.801c.146.146.146.437 0 .655l-2.474 2.475c-.218.146-.51.146-.655 0l-.8-.8-.219 2.329c0 .072-.073.218-.146.29l-4.658 4.659c-.145.146-.437.146-.655 0L.164 16.177c-.219-.146-.219-.437 0-.655l4.585-4.659c.04-.019.073-.038.104-.056.086-.05.154-.09.26-.09l2.257-.145h.073l-.801-.8c-.219-.219-.219-.51 0-.728ZM9.408 7.66 7.66 9.408l2.62 2.693 1.82-1.82-2.693-2.62ZM8.17 12.465l-.145 1.892-4.15 4.222-2.692-2.693 4.149-4.222 1.892-.145.946.946Zm4.295-4.295 1.892-.145 4.222-4.15-2.693-2.692-4.222 4.149-.145 1.892.946.946Zm-1.238 9.918c-.655 0-.655.947 0 .947 4.877 0 7.808-2.93 7.808-7.808 0-.655-.947-.655-.947 0 0 4.295-2.566 6.861-6.86 6.861Zm9.754-6.86c0-.656 1.019-.656 1.019 0C22 17.267 17.123 22 11.227 22c-.655 0-.655-1.019 0-1.019 5.314 0 9.754-4.295 9.754-9.754Zm-9.754 3.93c-.655 0-.655.946 0 .946a4.877 4.877 0 0 0 4.877-4.877c0-.655-.946-.655-.946 0a3.914 3.914 0 0 1-3.93 3.931Z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#satellite_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M-1-1h24v24H-1z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSatellite);
export default __webpack_public_path__ + "static/media/satellite.600d158f.svg";
export { ForwardRef as ReactComponent };